module.exports = __webpack_public_path__ + "static/media/announce_withus_home_responsive.501af4a3.png";